import styled from "styled-components";
export const Styles = styled.div`
  .title {
    margin-inline-start: 15px;
    font-weight: bold;
    text-align: start;
  }
  .description {
    margin-inline-start: 15px;
    text-align: start;
  }
  @media (max-width: 992px) {
    .title {
      margin-inline-start: 0px;
    }
    .description {
      margin-inline-start: 0px;
    }
  }
`;
